// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b58a4da1","947":"0db3168a"}[chunkId] + ".chunk.js";
};